import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './PublicNav.css';

/**
 * Oeffentliche Navigationsleiste.
 *
 * Der Login-Knopf führt seit 18.10.2026 auf die EINE Anmeldeseite /anmelden
 * (vorher ein eigenes Anmeldefenster, daneben /login und /anmelden).
 * @param {function} [onLoginClick] Ersetzt das, falls eine Seite etwas anderes will.
 */
export default function PublicNav({ onLoginClick, overlay = false }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen]       = useState(false);

  const isActive = (path) => location.pathname === path;

  // Angemeldet? Dann statt „Login“ der Weg in den eigenen Bereich
  // (18.10.2026: auf /registration stand für einen angemeldeten Admin „Login“).
  const eigenerBereich = (() => {
    try {
      if (!localStorage.getItem('token')) return null;
      if (localStorage.getItem('adminData')) return { pfad: '/dashboard', text: 'Zum Dashboard' };
      const club = JSON.parse(localStorage.getItem('clubData') || 'null');
      if (club?.user?.role === 'admin') return { pfad: '/dashboard', text: 'Zum Dashboard' };
      if (club?.user) return { pfad: '/verein', text: 'Mein Verein' };
    } catch { /* kaputter Speicher: wie abgemeldet behandeln */ }
    return null;
  })();

  const openLogin = () => {
    setMenuOpen(false);
    if (onLoginClick) onLoginClick();
    else navigate('/anmelden');
  };

  return (
    <>
      <nav className={`pub-nav${overlay ? ' pub-nav--overlay' : ''}`}>
        <div className="pub-nav-inner">
          <Link to="/" className="pub-nav-logo" onClick={() => setMenuOpen(false)}>
            <img src="/logo.webp" alt="TDA" />
            <span>TDA Tournament Center</span>
          </Link>

          {/* Desktop Links */}
          <div className="pub-nav-links">
            <Link to="/" className={`pub-nav-link${isActive('/') ? ' pub-nav-link--active' : ''}`}>
              Home
            </Link>
            <Link to="/ranking" className={`pub-nav-link${isActive('/ranking') ? ' pub-nav-link--active' : ''}`}>
              Ranking
            </Link>
            <Link to="/fuer-veranstalter" className={`pub-nav-link${isActive('/fuer-veranstalter') ? ' pub-nav-link--active' : ''}`}>
              Für Veranstalter
            </Link>
            <Link to="/apps" className={`pub-nav-link${isActive('/apps') ? ' pub-nav-link--active' : ''}`}>
              Apps
            </Link>
            <a href="https://tda-intl.org" className="pub-nav-link">TDA International</a>
            <Link to="/kontakt" className={`pub-nav-link${isActive('/kontakt') ? ' pub-nav-link--active' : ''}`}>Kontakt</Link>
            {eigenerBereich ? (
              <Link to={eigenerBereich.pfad} className="pub-nav-btn">{eigenerBereich.text}</Link>
            ) : (
              <>
                <Link to="/registrieren" className="pub-nav-link pub-nav-link--reg">Registrieren</Link>
                <button className="pub-nav-btn" onClick={openLogin}>Login</button>
              </>
            )}
          </div>

          {/* Mobile Hamburger */}
          <button
            className={`pub-nav-hamburger${menuOpen ? ' pub-nav-hamburger--open' : ''}`}
            onClick={() => setMenuOpen(o => !o)}
            aria-label="Menü"
          >
            <span /><span /><span />
          </button>
        </div>

        {/* Mobile Menu */}
        {menuOpen && (
          <div className="pub-nav-mobile" onClick={() => setMenuOpen(false)}>
            <Link to="/" className="pub-nav-mobile-link">Home</Link>
            <Link to="/ranking" className="pub-nav-mobile-link">Ranking</Link>
            <Link to="/fuer-veranstalter" className="pub-nav-mobile-link">Für Veranstalter</Link>
            <Link to="/apps" className="pub-nav-mobile-link">Apps</Link>
            <a href="https://tda-intl.org" className="pub-nav-mobile-link">TDA International</a>
            <Link to="/kontakt" className="pub-nav-mobile-link">Kontakt</Link>
            {eigenerBereich ? (
              <Link to={eigenerBereich.pfad} className="pub-nav-mobile-btn">{eigenerBereich.text}</Link>
            ) : (
              <>
                <Link to="/registrieren" className="pub-nav-mobile-link pub-nav-mobile-link--highlight">Registrieren</Link>
                <button className="pub-nav-mobile-btn" onClick={openLogin}>Login</button>
              </>
            )}
          </div>
        )}
      </nav>
    </>
  );
}
